import { uploadDocumentInitialState } from "@/livingInComponents/moveIn/constants";
import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  uploadDocumentState: uploadDocumentInitialState,
  moveInDate: "",
  moveInTime: "",
  selectedMoveInTimeSlot: null,
  activeStep: 1,
  unitId: "",
  salesOrderId: "",
  moveInDetails: {},
  availableTimeSlots: [],
};


const moveInJourneySlice = createSlice({
  name: "moveInJourneySlice",
  initialState: initialState,
  reducers: {
    resetDocUploadForm: (state) => {
      state.uploadDocumentState = uploadDocumentInitialState;
    },
    setDocUploadFormValues: (state: any, action) => {
      if (action.payload.isFile) {
        state.uploadDocumentState.values[action.payload.fieldName] = {
          ...(state.uploadDocumentState.values[action.payload.fieldName] || {}),
          ...(action.payload?.fieldValue || {}),
        };
      } else {
        state.uploadDocumentState.values[action.payload.fieldName] =
          action.payload?.fieldValue;
      }
    },
    setDocUploadFormLoading: (state: any, action) => {
      state.uploadDocumentState.loading[action.payload.fieldName] =
        action.payload.fieldValue;
    },
    setDocUploadFormErrors: (state: any, action) => {
      state.uploadDocumentState.errors[action.payload.fieldName] =
        action.payload.fieldValue;
    },
    setSelectedMoveInDate: (state: any, action) => {
      state.moveInDate = action.payload;
    },
    setSelectedMoveInTime: (state: any, action) => {
      state.moveInTime = action.payload;
    },
    setSelectedMoveInTimeSlot: (state: any, action) => {
      state.selectedMoveInTimeSlot = action.payload;
      state.moveInTime = action.payload?.displayTime ?? action.payload?.displayLabel ?? "";
    },
    setActiveStep: (state: any, action) => {
      state.activeStep = action.payload;
    },
    resetMoveInJourney: () => {
      return initialState;
    },
    startMoveInJourney: (state: any, action) => {
      return {
        ...state,
        activeStep: 1,
        moveInDate: "",
        moveInTime: "",
        selectedMoveInTimeSlot: null,
        ...action.payload,
      };
    },
    setMoveInDetails: (state: any, action) => {
      state.moveInDetails = action.payload;
    },
    setAvailableTimeSlots: (state: any, action) => {
      state.availableTimeSlots = action.payload;
    },
  },
});

export const {
  resetDocUploadForm,
  setDocUploadFormValues,
  setDocUploadFormLoading,
  setDocUploadFormErrors,
  setSelectedMoveInDate,
  setSelectedMoveInTime,
  setSelectedMoveInTimeSlot,
  resetMoveInJourney,
  setActiveStep,
  startMoveInJourney,
  setMoveInDetails,
  setAvailableTimeSlots,
} = moveInJourneySlice.actions;

export default moveInJourneySlice.reducer;
